import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=d16a543c"
import script from "./Prize.vue?vue&type=script&lang=js"
export * from "./Prize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports